export enum LossDisplayType {
    HideLoss = 1,
    ShowLoss = 2,
    ExcludeFromTotals = 3,
}